<template>
  <div class="about">  
    <router-link to="/"><Button back text="Back to home"/></router-link>
    <Map/>
    <div class="location">
      <div class="container">
        <h4>OUR<span> LOCATION</span></h4>
        <div class="location__info">
          <h5>99 KING STREET</h5>
          <ul>
            <li>Newport</li>
            <li>RI 02840</li>
            <li>United States of America</li>
          </ul>
          <p>Our newly opened gallery is located near the Edward King House on 99 King Street, the Modern Art Gallery is free to all visitors and open seven days a week from 8am to 9pm.</p>
        </div>
      </div>      
    </div>
  </div>
</template>

<script>
  import Button from '@/components/Button.vue';
  import Map from '@/components/Map.vue';

  export default {
    name: 'About',
    components: {Button, Map}
  }
</script>

<style scoped lang="scss">
  @import "../styles/_colors.scss";
  @import "../styles/_mixins.scss";
  @import "../styles/_fonts.scss";

  .about{position: relative;
   a{position: absolute; left: 156px; top:0; z-index: 2;}
   .location{background-color: $black; 
    .container{display: flex; gap: 17.25%; padding:104px 0 129px 166px;
      h4{@include font(7, 70, 0, $head, 900, white); max-width: 350px;
        span{letter-spacing: -0.6px;}
      }
      .location__info{
        h5{@include font(3.6, 36, 0, $head, 900, $gold);}
        p{@include font(2.2, 32, 0, $body, 400, white); max-width: 540px;}
        ul{margin: 24px 0 31px;
          li{@include font(2.2, 32, 0, $body, 400, white);}
        }
      }
    }    
  }

  @include mq(1400){
    .location{
      .container{gap: 11%;}
    }
  }

  @include mq(1300){
    a{left: 40px;}
    .location{
      .container{padding: 88px 40px;
        h4{font-size: 5.5rem; line-height: 50px; max-width: 275px;}
        .location__info{
          h5{font-size: 3.2rem; line-height: 32px;}
          p{font-size: 1.8rem; line-height:28px;}
          ul{margin: 16px 0 ;
            li{font-size: 1.8rem; line-height:28px;}
          }
        }
      }
    }
  }

  @include mq(705){
     a{left: 0;}
     .location{
      .container{padding: 48px 16px; flex-direction: column;
        h4{max-width: none;}
        .location__info{
          h5{margin: 40px 0px 25px;}
        }
      }
     }
  }
 }
</style>